module.exports = __webpack_public_path__ + "static/media/mailIcon.d10b0955.svg";